import React from 'react';
import { cache } from 'tm3-core/cache';

const LocalStorageHack = React.memo(() => {
  React.useEffect(() => {
    if (!localStorage.getItem('dbUpgrade')) {
      Object.keys(cache)
        .filter((x) => cache[x].onClear)
        .forEach((x) => cache[x].onClear());
      localStorage.setItem('dbUpgrade', 'true');
      const allowedRoutes = ['/recover', '/verify', '/auto-login', '/no-user'];
      if (!allowedRoutes.some((x) => !window.location.pathname.startsWith(x)))
        window.location.reload();
    }
  }, []);

  return null;
});

LocalStorageHack.displayName = 'LocalStorageHack';

export default LocalStorageHack;
